<template>
    <v-expansion-panel>
        <template>
            <v-expansion-panel-header class="mt-2">
                  Partida contable {{ ID_Accounting_item }}
  
                <template v-slot:actions>
                    <v-btn class="mr-5" @click.stop="reload()" icon small>
                        <v-icon color="primary">mdi-reload</v-icon>
                    </v-btn>
                    <v-btn @click.stop="$store.dispatch('deleteWindowByUuid',{uuid : win.uuid})" icon small>
                        <v-icon color="error">mdi-close</v-icon>
                    </v-btn>
                </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-tabs v-model="tab" dark background-color="primary" icons-and-text>
                    <v-tabs-slider color="red"></v-tabs-slider>
                    <v-tab href="#tab-1">
                      Partida contable
                        <v-icon>mdi-bank-minus</v-icon>
                    </v-tab>
                    <v-tab href="#tab-2" v-if="getAllowedImportAcounting">
                      Importacion de partidas
                        <v-icon>mdi-file-excel</v-icon>
                    </v-tab>
                </v-tabs>
  
                <v-tabs-items v-model="tab">
                    <v-tab-item value="tab-1">
                        <v-card class="pa-1">
                            <v-card-text class="white" style="border-radius: 10px;">
                                      <AccountingItem :win="win" :key="key" @updatingAccountingEntry="updatingHandler" />               
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item value="tab-2">
                        <v-card class="pa-1">
                            <v-card-text class="white" style="border-radius: 10px;">
                                      <AccountingEntryImport :win="win" :key="importKey" />
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                </v-tabs-items>
            </v-expansion-panel-content>
        </template>
        
    </v-expansion-panel>
  </template>
  
  <script>
    
    //import {mapState} from 'vuex';
    import AccountingItem from '../partial/AccountingItem.vue';
    import AccountingEntryImport from '../partial/AccountingEntryImport.vue';
  
    export default {
        name: "Acounting",
        components: {
            AccountingItem,
            AccountingEntryImport,
        },
        props: ['win'],
        data() {
            return {
                panel: 0,
                tab: null,
                key: 0,
                importKey: 0,
                ID_Accounting_item: ''
                
            }
        },
        computed:{
            /*...mapState('customerData', {
                tab: 'tab-1'
            }),*/
            getAllowedImportAcounting(){
                const tipoPlan = JSON.parse(localStorage.getItem("user"))?.TipoPlan ?? '';
                const preferentialPlan = parseInt(JSON.parse(localStorage.getItem("user"))?.preferentialplan ?? 0);
                return ['Professional', 'Advance', 'Contabilidad'].includes(tipoPlan) || preferentialPlan == 1;
            }
        },
        methods: {
            reload() {
                this.key++;
                setTimeout(() => {
                window.scrollTo(0, this.$store.getters.getScrollTop)
                //alert(this.$store.getters.getScrollTop)
                },300);
            },
            updatingHandler(value){
                this.ID_Accounting_item = value;
            }
        },
  
    }
  </script>